"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStepperStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/commons/_colors");
exports.useStepperStyles = (0, core_1.makeStyles)(function () { return ({
    iconRoot: {
        color: _colors_1.mediumLightBlue,
        height: 18,
        paddingTop: 1,
    },
    iconCompleted: {
        color: _colors_1.mediumGreen,
    },
    active: {},
    completed: {},
    stepButton: {
        padding: 0,
        margin: 0,
    },
    step: {
        padding: 0,
    },
    iconContainer: {
        paddingRight: 0,
    },
    label: {
        fontSize: 14,
        color: _colors_1.mediumLightBlue,
        fontWeight: 500,
        '&$active': {
            color: _colors_1.mediumGreen,
        },
        '&$completed': {
            color: _colors_1.mediumGreen,
        },
    },
}); });
